import dayjs from 'dayjs';

export const CUSTOMER_RECLAIM_STATUS_CARDS = [
  {
    key: 'received',
    title: '접수',
    statuses: ['RECEIVED'],
  },
  {
    key: 'shipping',
    title: '회수중',
    statuses: ['SHIPPING'],
  },
  {
    key: 'completed',
    title: '완료',
    statuses: ['RECLAIMED'],
  },
];

const getReclaimSortValue = (reclaim) => {
  if (reclaim?.createdAt) return dayjs(reclaim.createdAt).valueOf();
  return 0;
};

export const sortReclaimsByLatest = (reclaims = []) => {
  return [...reclaims].sort(
    (left, right) => getReclaimSortValue(right) - getReclaimSortValue(left),
  );
};

export const buildReclaimStatusSummary = (reclaims = []) => {
  return CUSTOMER_RECLAIM_STATUS_CARDS.reduce((summary, card) => {
    summary[card.key] = reclaims.filter((reclaim) =>
      card.statuses.includes(reclaim.status),
    ).length;
    return summary;
  }, {});
};

export const getRecentReclaims = (reclaims = [], limit = 10) => {
  return sortReclaimsByLatest(reclaims).slice(0, limit);
};

export const buildReclaimChartData = (reclaims = [], from, to) => {
  if (!from || !to) return [];

  const nextData = [];
  let currentDate = from.startOf('day');
  const endDate = to.startOf('day');

  while (
    currentDate.isSame(endDate, 'day') ||
    currentDate.isBefore(endDate, 'day')
  ) {
    const targetDate = currentDate.format('YYYYMMDD');
    const targetLabel = currentDate.format('M/D');

    nextData.push({
      label: targetLabel,
      date: targetDate,
      count: reclaims.filter(
        (reclaim) => dayjs(reclaim.createdAt).format('YYYYMMDD') === targetDate,
      ).length,
    });

    currentDate = currentDate.add(1, 'day');
  }

  return nextData;
};

export const filterReclaimsByDate = (reclaims = [], yyyymmdd) => {
  return reclaims.filter(
    (reclaim) => dayjs(reclaim.createdAt).format('YYYYMMDD') === yyyymmdd,
  );
};
